import Splide from '@splidejs/splide';

const SPLIDE_OPTIONS = {
  perPage: 1,
  pagination: false,
  arrows: false,
  trimSpace: false,
  focus: 'center',
  padding: '48px',
  gap: '16px',
  heightRatio: 1.55,
  breakpoints: {
    500: {
      trimSpace: true,
    },
    768: {
      trimSpace: false,
      fixedWidth: 430,
      heightRatio: 1,
      gap: '2rem',
      padding: '2rem',
    },
    1024: {
      trimSpace: false,
      fixedWidth: 530,
      heightRatio: 0.9,
      gap: '2rem',
      padding: '2rem',
    },
  },
};

const hasSlider = {
  beforeDestroy() {
    this.destroySlider();
  },
  data: () => ({
    sliderIndex: 0,
  }),
  methods: {
    initSlider() {
      if (this.$splide) {
        this.$splide.destroy();
        this.$splide = null;
      }
      const $splide = document.querySelector('.splide');
      if ($splide) {
        const options = { ...SPLIDE_OPTIONS, start: this.sliderIndex };
        this.$splide = new Splide($splide, options).mount();
        this.$splide.on('moved', index => {
          this.sliderIndex = index;
        });
      } else {
        console.log('slide container is not there');
      }
    },
    destroySlider() {
      if (this.$splide) {
        this.$splide.destroy();
      }
      this.$splide = null;
    },
    resetSlider() {
      return new Promise(resolve => {
        this.$nextTick(() => {
          if (this.$splide) {
            this.$splide.refresh();
          } else {
            this.initSlider();
          }
          resolve();
        });
      });
    },
  },
};

export default hasSlider;
